import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IApiRequest, IDropTypeResponse } from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const GET_DROP_TYPES_UUID = createUUID();
const GET_RECENT_DROP_TYPES_UUID = createUUID();

export const useDropTypes = () => {
  const [dropTypes, setDropTypes] = useState<IDropTypeResponse[]>([]);
  const [recentDropTypes, setRecentDropTypes] = useState<IDropTypeResponse[]>(
    []
  );

  const stateManager = useComponentState();

  const getDropTypes = async ({ top, skip, search = "" }: IApiRequest = {}) => {
    stateManager.abort(GET_DROP_TYPES_UUID);

    const response = await stateManager.run(async () => {
      return homeService.dropTypes.getAll({
        top,
        skip,
        sort: "name asc",
        filters: { name: { contains: search } },
      });
    }, GET_DROP_TYPES_UUID);
    if (response.status === HTTP_STATUSES.OK) {
      setDropTypes(response.data);
    }
    return response;
  };

  const getRecentDropTypes = async ({
    sort,
    filters,
    top,
    search = "",
  }: IApiRequest) => {
    stateManager.abort(GET_RECENT_DROP_TYPES_UUID);

    const response = await stateManager.run(async () => {
      return homeService.dropTypes.getAll({
        sort,
        top,
        filters: {
          ...filters,
          name: { contains: search },
        },
      });
    }, GET_RECENT_DROP_TYPES_UUID);
    if (response.status === HTTP_STATUSES.OK) {
      setRecentDropTypes(response.data);
    }
    return response;
  };

  return {
    isLoading: stateManager.isBusy(),
    dropTypes,
    recentDropTypes,
    setDropTypes,
    setRecentDropTypes,
    getDropTypes,
    getRecentDropTypes,
  };
};
